import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBGpPb_7xQcntJ152h856PdM16lC8nDJ8Y",
  authDomain: "maniera-digital-f4bd9.firebaseapp.com",
  projectId: "maniera-digital-f4bd9",
  storageBucket: "maniera-digital-f4bd9.firebasestorage.app",
  messagingSenderId: "764955333862",
  appId: "1:764955333862:web:2645e6a999b21b417b9727"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app); 